import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  siderWidth: 208,
  pwa: false,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: { header: { heightLayoutHeader: 44 } },
  menu: { defaultOpenAll: true, ignoreFlatMenu: true, autoClose: false },
  splitMenus: false,
};
export default Settings;
